import React from 'react';

import { Modal } from 'src/components/common';
import { InvitePeoByPeoPpModalContent } from 'src/components/peo';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

type InvitePeoByPeoPpModalProps = {
  peoPayrollProviderId?: string;
};

export const InvitePeoByPeoPpModal: React.FC<InvitePeoByPeoPpModalProps> = ({
  peoPayrollProviderId,
}) => {
  const { closeModal, switchClosability, isOpen } = useModal(ModalId.InvitePeoByPeoPp);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Add PEOs"
      headerPadding="32px 32px 8px 32px"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
    >
      <InvitePeoByPeoPpModalContent
        closeModal={onCloseModal}
        switchClosability={switchClosability}
        peoPayrollProviderId={peoPayrollProviderId}
      />
    </Modal>
  );
};
